import React from "react";
import FormStart from "../../../form/manualDrawer/FormStart";
import ManualDrawer from "../../../../stories/_setting/ManualDrawers/ManualDrawer";
import '../../../../css/overbox/ManualDrawerInformation.css';

const NewObject = props => {
    const { handleIndex } = props;

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox start">
                    <FormStart object={ new ManualDrawer() } handleIndex={ handleIndex } />
                </div>
            </div>
        </div>
    )
}

export default NewObject;
